const SRI_LANKA_LOCATIONS = [
  {
    province: 'Western',
    districts: [
      {
        name: 'Colombo',
        cities: [
          'Colombo', 'Dehiwala', 'Mount Lavinia', 'Moratuwa', 'Maharagama',
          'Sri Jayawardenepura Kotte', 'Kaduwela', 'Homagama', 'Kolonnawa',
          'Avissawella', 'Padukka', 'Hanwella', 'Boralesgamuwa', 'Kesbewa',
        ],
      },
      {
        name: 'Gampaha',
        cities: [
          'Gampaha', 'Negombo', 'Ja-Ela', 'Wattala', 'Kelaniya',
          'Minuwangoda', 'Divulapitiya', 'Mirigama', 'Veyangoda',
          'Ganemulla', 'Ragama', 'Katunayake',
        ],
      },
      {
        name: 'Kalutara',
        cities: [
          'Kalutara', 'Panadura', 'Beruwala', 'Aluthgama', 'Horana',
          'Matugama', 'Bandaragama', 'Wadduwa', 'Ingiriya',
        ],
      },
    ],
  },
  {
    province: 'Central',
    districts: [
      {
        name: 'Kandy',
        cities: [
          'Kandy', 'Peradeniya', 'Katugastota', 'Gampola', 'Nawalapitiya',
          'Kundasale', 'Digana', 'Galagedara',
        ],
      },
      {
        name: 'Matale',
        cities: ['Matale', 'Dambulla', 'Sigiriya', 'Ukuwela', 'Rattota'],
      },
      {
        name: 'Nuwara Eliya',
        cities: ['Nuwara Eliya', 'Hatton', 'Talawakele', 'Ragala', 'Walapane'],
      },
    ],
  },
  {
    province: 'Southern',
    districts: [
      {
        name: 'Galle',
        cities: [
          'Galle', 'Ambalangoda', 'Hikkaduwa', 'Elpitiya', 'Baddegama', 'Karapitiya',
        ],
      },
      {
        name: 'Matara',
        cities: ['Matara', 'Weligama', 'Akuressa', 'Dikwella', 'Kamburugamuwa'],
      },
      {
        name: 'Hambantota',
        cities: ['Hambantota', 'Tangalle', 'Beliatta', 'Tissamaharama', 'Ambalantota'],
      },
    ],
  },
  {
    province: 'Northern',
    districts: [
      {
        name: 'Jaffna',
        cities: ['Jaffna', 'Nallur', 'Chavakachcheri', 'Point Pedro', 'Karainagar'],
      },
      {
        name: 'Kilinochchi',
        cities: ['Kilinochchi', 'Poonakary', 'Paranthan'],
      },
      {
        name: 'Mullaitivu',
        cities: ['Mullaitivu', 'Oddusuddan', 'Puthukudiyiruppu'],
      },
      {
        name: 'Mannar',
        cities: ['Mannar', 'Talaimannar', 'Murunkan'],
      },
      {
        name: 'Vavuniya',
        cities: ['Vavuniya', 'Cheddikulam', 'Nelukkulam'],
      },
    ],
  },
  {
    province: 'Eastern',
    districts: [
      {
        name: 'Trincomalee',
        cities: ['Trincomalee', 'Kinniya', 'Kantale', 'Mutur'],
      },
      {
        name: 'Batticaloa',
        cities: ['Batticaloa', 'Eravur', 'Kattankudy', 'Kaluwanchikudy'],
      },
      {
        name: 'Ampara',
        cities: [
          'Ampara', 'Kalmunai', 'Akkaraipattu', 'Sammanthurai', 'Dehiattakandiya',
        ],
      },
    ],
  },
  {
    province: 'North Western',
    districts: [
      {
        name: 'Kurunegala',
        cities: [
          'Kurunegala', 'Kuliyapitiya', 'Pannala', 'Wariyapola', 'Narammala', 'Polgahawela',
        ],
      },
      {
        name: 'Puttalam',
        cities: ['Puttalam', 'Chilaw', 'Wennappuwa', 'Marawila', 'Anamaduwa'],
      },
    ],
  },
  {
    province: 'North Central',
    districts: [
      {
        name: 'Anuradhapura',
        cities: [
          'Anuradhapura', 'Kekirawa', 'Medawachchiya', 'Thambuttegama', 'Galenbindunuwewa',
        ],
      },
      {
        name: 'Polonnaruwa',
        cities: ['Polonnaruwa', 'Kaduruwela', 'Hingurakgoda', 'Medirigiriya'],
      },
    ],
  },
  {
    province: 'Uva',
    districts: [
      {
        name: 'Badulla',
        cities: ['Badulla', 'Bandarawela', 'Ella', 'Welimada', 'Haputale'],
      },
      {
        name: 'Monaragala',
        cities: ['Monaragala', 'Wellawaya', 'Bibile', 'Kataragama'],
      },
    ],
  },
  {
    province: 'Sabaragamuwa',
    districts: [
      {
        name: 'Ratnapura',
        cities: ['Ratnapura', 'Balangoda', 'Embilipitiya', 'Pelmadulla', 'Eheliyagoda'],
      },
      {
        name: 'Kegalle',
        cities: ['Kegalle', 'Mawanella', 'Rambukkana', 'Warakapola', 'Ruwanwella'],
      },
    ],
  },
];

export default SRI_LANKA_LOCATIONS;
